import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import GeneralFilters from "src/features/conversations/GeneralFilters";
import PageNavBreadcrumbs from "src/features/breadcrumbs/PageNavBreadcrumbs";
import BaseHeader from "src/pages/layout/Header";
import "./Header.scss";
const Header = () => {
    return (_jsxs(BaseHeader, { className: 'conversations-header', children: [_jsx(PageNavBreadcrumbs, {}), _jsx(GeneralFilters, {})] }));
};
export default Header;
